import { MaUIWithNavbarLayout } from "@ip-layout";
import { ErrorPanel } from "@ip-widgets/Tailwind/common/error";

type Props = {
  error: any;
};

export default function MaUIErrorHandlingScreen({ error }: Props) {
  return (
    <MaUIWithNavbarLayout>
      <div className="px-4 py-6 space-y-6 bg-white sm:p-6">
        <ErrorPanel error={error} />
      </div>
    </MaUIWithNavbarLayout>
  );
}
